import { render, staticRenderFns } from "./GoodsSummary.vue?vue&type=template&id=6eb70808&scoped=true"
import script from "./GoodsSummary.vue?vue&type=script&lang=js"
export * from "./GoodsSummary.vue?vue&type=script&lang=js"
import style1 from "./GoodsSummary.vue?vue&type=style&index=1&id=6eb70808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb70808",
  null
  
)

export default component.exports